import { render, staticRenderFns } from "./ReservaView.vue?vue&type=template&id=77d96859&"
import script from "./ReservaView.vue?vue&type=script&lang=ts&"
export * from "./ReservaView.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports